// extracted by mini-css-extract-plugin
export default {"title":"ListToggle_title__Lkh13"};